import { render, staticRenderFns } from "./baseEdit.vue?vue&type=template&id=c23c27b2&scoped=true"
import script from "./baseEdit.vue?vue&type=script&lang=js"
export * from "./baseEdit.vue?vue&type=script&lang=js"
import style0 from "./baseEdit.vue?vue&type=style&index=0&id=c23c27b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23c27b2",
  null
  
)

export default component.exports